import React, {useState, createContext, useLayoutEffect} from 'react';
import {useracc} from './functions';
export const UserContext = createContext();

export const UserProvider = (props) => {
	const [user, setUser] = useState({});
	const [themes, setThemes] = useState('/themes/default-dark.css');
	const [colours, setColours] = useState('/themes/default');

	useLayoutEffect(() => {
    (async () => {
			const getUser = await useracc();
			setUser( getUser );
		})();
  }, []);

	const setTheme = (_themes) => {
		//console.log(themes, _themes);
		if( _themes !== themes ) {
			setThemes(_themes);
			var link = document.createElement('link');
			link.href = _themes;
			link.id = '_themes';
			link.rel = 'stylesheet';
			link.type = 'text/css';
			var element = document.getElementById('_themes');
			if( element ) element.parentNode.replaceChild(link,element);
		}
	};
	
	const setColour = (_colour) => {
		if( _colour !== colours ) {
			setColours(_colour);
			var link = document.createElement('link');
			link.href = _colour;
			link.id = '_colour'
			link.rel = 'stylesheet';
			link.type = 'text/css';
			var element = document.getElementById('_colour');
			if( element ) element.parentNode.replaceChild(link,element);
		}
	}

	return (
		<UserContext.Provider value={{user, setUser, setTheme, setColour}}>
			<link rel="stylesheet" id="_themes" type="text/css" href={`${themes}`} />
			{props.children}
		</UserContext.Provider>
	);
}